import api from '@/api';
import imp from '@/lib/imp';
import { UvRoute } from '@/lib/router';
import { InventoryImportSource, ScripticItemType } from '@/pages/inventory/Inventory';

const baseRouteName = `inventory.active.import.${InventoryImportSource.QUASH}.${ScripticItemType.MF}`;

const route: UvRoute = {
  path: ScripticItemType.MF,
  name: baseRouteName,
  props: (route) => ({
    ...route.params,
    baseRouteName,
  }),
  meta: {
    header: {
      label: 'Lista cu mijloace fixe importate',
      menu: (route, { inventory }) => [
        {
          label: 'Adauga casare noua',
          icon: 'add',
          disabled: inventory ? !inventory.config.types.mf.import.enabled : false,
          separated: true,
          route: {
            name: `${baseRouteName}.create`,
            params: route.params,
          },
        },
        {
          label: 'Importa',
          icon: 'arrow_upward',
          disabled: inventory ? !inventory.config.types.mf.import.enabled : false,
          separated: true,
          route: {
            name: `${baseRouteName}.upload`,
            params: route.params,
          },
        },
      ],
    },
    breadcrumb: {
      label: 'Lista cu mijloace fixe importate',
      route: baseRouteName,
    },
  },
  component: imp(
    () =>
      import(
        '@/pages/inventory/active/import/quash/lists/mf/Main.vue' /* webpackChunkName: 'inventory.active.import.quash' */
      ),
  ),
  children: [
    {
      path: 'create',
      name: `${baseRouteName}.create`,
      component: imp(
        () =>
          import(
            '@/pages/inventory/active/import/quash/lists/mf/actions/Create.vue' /* webpackChunkName: 'inventory.active.import.quash' */
          ),
      ),
      props: (route) => ({
        ...route.params,
        baseRouteName,
      }),
    },
    {
      path: 'edit/:itemId',
      component: imp(
        () =>
          import(
            '@/pages/inventory/active/import/quash/lists/mf/quantities/Main.vue' /* webpackChunkName: 'inventory.active.import.quash' */
          ),
      ),
      props: (route) => ({
        ...route.params,
        baseRouteName,
      }),
      children: [
        {
          path: '',
          name: `${baseRouteName}.edit`,
          component: imp(
            () =>
              import(
                '@/pages/inventory/active/import/quash/lists/mf/quantities/Edit.vue' /* webpackChunkName: 'inventory.active.import.quash' */
              ),
          ),
          props: (route) => ({
            ...route.params,
            baseRouteName,
          }),
        },
      ],
    },
    {
      path: 'upload',
      name: `${baseRouteName}.upload`,
      props: {
        source: InventoryImportSource.QUASH,
        type: ScripticItemType.MF,
        api: api.inventory.import.upload,
        title: 'Incarca casari de mijloace fixe',
        parentRoute: { name: baseRouteName },
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      parentRoute: { name: `${baseRouteName}.upload` },
      component: imp(
        () =>
          import(
            '@/pages/inventory/active/import/common/Upload.vue' /* webpackChunkName: 'inventory.active.import.quash' */
          ),
      ),
    },
  ],
};

export default route;
